import Reveal from "@/components/base/Reveal";

const heroImage =
  "https://readdy.ai/api/search-image?query=Silhouette%20of%20a%20young%20singer%20holding%20microphone%20on%20a%20dark%20arena%20stage%20under%20dramatic%20warm%20orange%20spotlights%2C%20golden%20confetti%20falling%2C%20packed%20crowd%20with%20lightsticks%20below%2C%20editorial%20entertainment%20magazine%20photography%2C%20crimson%20and%20amber%20rim%20lighting%2C%20subtle%20film%20grain%2C%20high%20contrast%2C%20vertical%20hero%20composition&width=900&height=1120&seq=hero-cover-2026&orientation=portrait";

const stats = [
  { num: "3,600+", label: "公开热点整理" },
  { num: "240", label: "打榜攻略" },
  { num: "860", label: "直拍对比" },
  { num: "12", label: "热门赛程追踪" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden border-b border-background-300/70">
      {/* decorative watermark */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-6 top-6 select-none font-serif text-[16vw] font-black leading-none text-primary-100/70 md:right-10 md:text-[11rem]"
      >
        今日
      </div>

      <div className="container-x relative py-10 md:py-14">
        {/* breaking ticker */}
        <Reveal>
          <div className="mb-8 flex items-stretch gap-0 overflow-hidden rounded-md border border-background-300/70 bg-background-100">
            <span className="flex shrink-0 items-center gap-1.5 bg-primary-600 px-3 py-2 text-xs font-bold text-background-50">
              <i className="ri-fire-fill" aria-hidden="true" />
              爆点
            </span>
            <p className="truncate px-3 py-2 text-[13px] font-medium text-foreground-800">
              第12期舞台直拍对比更新 · 新规则打榜入口已接入 · 35强淘汰名单争议持续发酵中
            </p>
          </div>
        </Reveal>

        <div className="grid items-center gap-10 lg:grid-cols-12 lg:gap-8">
          {/* left copy */}
          <div className="lg:col-span-7">
            <Reveal>
              <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.22em] text-primary-600">
                <i className="ri-live-line" aria-hidden="true" />
                每日更新 · 吃瓜不打烊
              </div>
              <h1 className="mt-4 font-serif text-4xl font-black leading-[1.15] tracking-tight text-foreground-950 md:text-6xl">
                选秀打榜与吃瓜
                <br />
                的<span className="text-primary-600">第一现场</span>
              </h1>
            </Reveal>

            <Reveal delay={80}>
              <p className="mt-6 max-w-xl text-[15px] leading-7 text-foreground-600 md:text-base">
                每日大赛网是一站式选秀追踪站：汇总<span className="font-semibold text-foreground-800">投票打榜攻略</span>、
                逐帧做<span className="font-semibold text-foreground-800">舞台直拍对比</span>，同步梳理
                <span className="font-semibold text-foreground-800">选手热议旧料</span>、
                <span className="font-semibold text-foreground-800">导师点评争议</span>与
                <span className="font-semibold text-foreground-800">淘汰内幕</span>。事实与观点分开标注，
                让你看得懂赛程，也吃得明白瓜。
              </p>
            </Reveal>

            <Reveal delay={140}>
              <div className="mt-6 flex flex-wrap items-center gap-2">
                {["今日热搜榜刷新", "打榜规则对照", "直拍版本对比", "淘汰内幕追踪"].map((t) => (
                  <span
                    key={t}
                    className="chip bg-secondary-100 text-secondary-800"
                  >
                    <i className="ri-checkbox-circle-line mr-1" aria-hidden="true" />
                    {t}
                  </span>
                ))}
              </div>
            </Reveal>

            <Reveal delay={200}>
              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <a
                  href="#hot"
                  className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-700"
                >
                  去热搜吃瓜
                  <i className="ri-arrow-down-line" aria-hidden="true" />
                </a>
                <a
                  href="#poll"
                  className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 bg-background-50 px-6 py-3 text-sm font-bold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
                >
                  查看打榜攻略
                </a>
              </div>
            </Reveal>

            <Reveal delay={260}>
              <dl className="mt-10 grid grid-cols-2 gap-6 border-t border-background-300/70 pt-6 sm:grid-cols-4">
                {stats.map((s) => (
                  <div key={s.label}>
                    <dt className="order-2 text-[11px] font-medium text-foreground-500">{s.label}</dt>
                    <dd className="headline-en text-2xl font-black text-foreground-950">
                      <span className="text-accent-500">{s.num}</span>
                    </dd>
                  </div>
                ))}
              </dl>
            </Reveal>
          </div>

          {/* right cover */}
          <div className="lg:col-span-5">
            <Reveal delay={120}>
              <figure className="relative">
                <div className="absolute -left-3 -top-3 h-full w-full rounded-lg border-2 border-primary-300" aria-hidden="true" />
                <img
                  src={heroImage}
                  alt="选秀选手在舞台上演唱，现场灯牌与金色彩带营造热烈气氛"
                  title="每日大赛网 · 舞台现场"
                  className="relative h-[380px] w-full rounded-lg object-cover object-top md:h-[500px]"
                />
                <figcaption className="absolute inset-x-3 bottom-3 flex items-center justify-between rounded-md bg-background-950/85 px-4 py-3 backdrop-blur">
                  <span className="text-xs font-medium text-background-100">
                    今日封面 · 现场直击《星光主理人》第12期
                  </span>
                  <span className="chip bg-primary-500 text-background-50">直播</span>
                </figcaption>
              </figure>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}